import { render, staticRenderFns } from "./OtherInterestContacts.vue?vue&type=template&id=1df3a08a"
import script from "./OtherInterestContacts.vue?vue&type=script&lang=js"
export * from "./OtherInterestContacts.vue?vue&type=script&lang=js"
import style0 from "./OtherInterestContacts.vue?vue&type=style&index=0&id=1df3a08a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports